(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["appwash-contact"] && !Shopify.designMode) return;
  try {
    

function initAppwashCoverage(root) {
 if(root.dataset.ready) return;
 root.dataset.ready="true";
 const data=JSON.parse(root.querySelector(".awc-data").textContent),t=data.texts;
 const input=root.querySelector("input"),ticket=root.querySelector(".awc-ticket"),error=root.querySelector(".awc-error");
 const norm=s=>s.normalize("NFD").replace(/[\u0300-\u036f]/g,"").toLowerCase().trim().replace(/\s+/g," ");
 function show(){
  let value=norm(input.value); if(value==="santiago centro") value="santiago";
  const found=data.communes.find(c=>norm(c)===value);
  if(!value){ticket.hidden=true;error.textContent=t.empty;input.setAttribute("aria-invalid","true");return;}
  input.removeAttribute("aria-invalid");error.textContent="";
  const state=found?"yes":value==="san bernardo"?"no":"unknown";
  ticket.hidden=false;ticket.dataset.state=state;
  root.querySelector(".awc-icon").textContent=found?"✓":state==="no"?"×":"?";
  root.querySelector(".awc-result-title").textContent=t[state];
  root.querySelector(".awc-result-comuna").textContent=found||input.value.trim();
  root.querySelector(".awc-result-rule").textContent=found==="La Florida"?t.florida:found==="Maipú"?t.maipu:"";
  root.querySelector(".awc-result-detail").textContent=found?t.general:t[state+"_text"];
  root.querySelector(".awc-result-buy").hidden=!found;
 }
 root.querySelector("form").addEventListener("submit",e=>{e.preventDefault();show();});
 input.addEventListener("input",()=>{ticket.hidden=true;error.textContent="";input.removeAttribute("aria-invalid");if(data.communes.some(c=>norm(c)===norm(input.value)))show();});
 root.querySelector(".awc-result-consult").addEventListener("click",()=>{
  const form=document.getElementById("AppwashContact");if(!form)return;
  const body=form.querySelector('[name="contact[body]"]');
  if(body&&!body.value) body.value=t.label+" "+input.value.trim();
  const topic=form.querySelector("select");if(topic&&topic.options.length>3)topic.selectedIndex=3;
  requestAnimationFrame(()=>body?.focus());
 });
}
document.querySelectorAll("[data-coverage-checker]").forEach(initAppwashCoverage);
document.addEventListener("shopify:section:load",e=>e.target.querySelectorAll("[data-coverage-checker]").forEach(initAppwashCoverage));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["appwash-home"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    root.querySelectorAll('.aw-home').forEach(home => {
      const format = JSON.parse(home.querySelector('[data-aw-format]').textContent);
      const money = new Intl.NumberFormat(format.locale || 'es-CL', {style:'currency',currency:format.currency});
      home.querySelectorAll('.aw-product-form').forEach(form => {
        if (form.dataset.awReady) return;
        form.dataset.awReady = 'true';
        const select = form.querySelector('[data-aw-variant]');
        const quantity = form.querySelector('[data-aw-quantity]');
        const rules = JSON.parse(form.querySelector('[data-aw-rules]').textContent);
        const output = form.querySelector('[data-aw-total]');
        const totalRow = form.querySelector('[data-aw-total-row]');
        function update(changeVariant) {
          const option = select.selectedOptions[0];
          if (!option) return;
          if (changeVariant) {
            const rule = rules[select.value];
            quantity.min = rule.min; quantity.step = rule.step;
            if (rule.max !== null) quantity.max = rule.max; else quantity.removeAttribute('max');
            quantity.value = rule.min;
          }
          const valid = quantity.checkValidity();
          totalRow.hidden = !valid;
          if (valid) output.textContent = money.format(Number(option.dataset.price) * Number(quantity.value) / 100);
          form.querySelector('[name="add"]').disabled = option.dataset.available !== 'true';
        }
        select.addEventListener('change', () => update(true));
        quantity.addEventListener('input', () => update(false));
        update(false);
      });
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document)); else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["appwash-product"]) return;
  try {
    
(() => {
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
  function init(root) {
    root.querySelectorAll('.aws').forEach(section => {
      if(section.dataset.awsReady) return;
      section.dataset.awsReady = 'true';
      const config = JSON.parse(section.querySelector('[data-aws-config]').textContent);
      const currency = new Intl.NumberFormat(config.locale || 'es-CL',{style:'currency',currency:config.currency});
      const dialog = section.querySelector('.aws-zoom');
      section.querySelectorAll('[data-aws-zoom]').forEach(link => link.addEventListener('click',event => {
        if (!dialog || !dialog.showModal) return;
        event.preventDefault();
        const img = dialog.querySelector('img');
        img.src = link.href; img.alt = link.querySelector('img')?.alt || '';
        dialog.showModal();
      }));
      dialog?.querySelector('[data-aws-close]').addEventListener('click',() => dialog.close());
      dialog?.addEventListener('click',event => {if(event.target === dialog) dialog.close();});
      const cards = [...section.querySelectorAll('[data-aws-card]')];
      const buttons = [...section.querySelectorAll('[data-aws-filter]')];
      const search = section.querySelector('[data-aws-search]');
      const result = section.querySelector('[data-aws-result]');
      let active = 'all';
      function filter() {
        const term = normalize(search.value.trim()); let count = 0;
        cards.forEach(card => {
          const visible = (active === 'all' || card.dataset.category === active) && normalize(card.dataset.search).includes(term);
          card.hidden = !visible; if(visible) count++;
        });
        result.textContent = config.countLabel + ' ' + count;
        section.querySelector('[data-aws-empty]').hidden = count !== 0;
      }
      if (search) {
      section.querySelector('[data-aws-tools]').hidden = false;
      result.hidden = false;
      buttons.forEach(button => button.addEventListener('click',() => {
        active = button.dataset.awsFilter;
        buttons.forEach(item => item.setAttribute('aria-pressed',String(item === button)));
        filter();
      }));
      search.addEventListener('input',filter); filter();
      }
      section.querySelectorAll('.aws-form').forEach(form => {
        const select = form.querySelector('[data-aws-variant]');
        const quantity = form.querySelector('[data-aws-quantity]');
        function update(changed) {
          const option = select.selectedOptions[0]; if(!option) return;
          if(changed) {
            quantity.min = option.dataset.min; quantity.step = option.dataset.step;
            if(option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
            quantity.value = option.dataset.min;
          }
          const valid = quantity.checkValidity();
          form.querySelector('[data-aws-total-row]').hidden = !valid;
          if(valid) form.querySelector('[data-aws-total]').textContent = currency.format(Number(option.dataset.price) * Number(quantity.value) / 100);
          form.querySelector('[name="add"]').disabled = option.dataset.available !== 'true';
        }
        select.addEventListener('change',() => update(true)); quantity.addEventListener('input',() => update(false)); update(false);
      });
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => init(document)); else init(document);
  document.addEventListener('shopify:section:load',event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["appwash-services"] && !Shopify.designMode) return;
  try {
    
(() => {
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
  function init(root) {
    root.querySelectorAll('.aws').forEach(section => {
      if(section.dataset.awsReady) return;
      section.dataset.awsReady = 'true';
      const config = JSON.parse(section.querySelector('[data-aws-config]').textContent);
      const currency = new Intl.NumberFormat(config.locale || 'es-CL',{style:'currency',currency:config.currency});
      const dialog = section.querySelector('.aws-zoom');
      section.querySelectorAll('[data-aws-zoom]').forEach(link => link.addEventListener('click',event => {
        if (!dialog || !dialog.showModal) return;
        event.preventDefault();
        const img = dialog.querySelector('img');
        img.src = link.href; img.alt = link.querySelector('img')?.alt || '';
        dialog.showModal();
      }));
      dialog?.querySelector('[data-aws-close]').addEventListener('click',() => dialog.close());
      dialog?.addEventListener('click',event => {if(event.target === dialog) dialog.close();});
      const cards = [...section.querySelectorAll('[data-aws-card]')];
      const buttons = [...section.querySelectorAll('[data-aws-filter]')];
      const search = section.querySelector('[data-aws-search]');
      const result = section.querySelector('[data-aws-result]');
      let active = 'all';
      function filter() {
        const term = normalize(search.value.trim()); let count = 0;
        cards.forEach(card => {
          const visible = (active === 'all' || card.dataset.category === active) && normalize(card.dataset.search).includes(term);
          card.hidden = !visible; if(visible) count++;
        });
        result.textContent = config.countLabel + ' ' + count;
        section.querySelector('[data-aws-empty]').hidden = count !== 0;
      }
      if (search) {
      section.querySelector('[data-aws-tools]').hidden = false;
      result.hidden = false;
      buttons.forEach(button => button.addEventListener('click',() => {
        active = button.dataset.awsFilter;
        buttons.forEach(item => item.setAttribute('aria-pressed',String(item === button)));
        filter();
      }));
      search.addEventListener('input',filter); filter();
      }
      section.querySelectorAll('.aws-form').forEach(form => {
        const select = form.querySelector('[data-aws-variant]');
        const quantity = form.querySelector('[data-aws-quantity]');
        function update(changed) {
          const option = select.selectedOptions[0]; if(!option) return;
          if(changed) {
            quantity.min = option.dataset.min; quantity.step = option.dataset.step;
            if(option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
            quantity.value = option.dataset.min;
          }
          const valid = quantity.checkValidity();
          form.querySelector('[data-aws-total-row]').hidden = !valid;
          if(valid) form.querySelector('[data-aws-total]').textContent = currency.format(Number(option.dataset.price) * Number(quantity.value) / 100);
          form.querySelector('[name="add"]').disabled = option.dataset.available !== 'true';
        }
        select.addEventListener('change',() => update(true)); quantity.addEventListener('input',() => update(false)); update(false);
      });
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => init(document)); else init(document);
  document.addEventListener('shopify:section:load',event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
